import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { EventCardInfo, EventData } from "../../types";
import { EventOutdateIcon } from "../../icons/event/outdated";
import { EventFinishedIcon } from "../../icons/event/finished";
import { EventPlannedIcon } from "../../icons/event/planned";
import { formatDateOfEvent, generateRandomString, getDeclinedWord } from "../../utils";
import ShortManInfo from "../ui/shortItem";
import { closeModal, openModal } from "../../state/modalSlice";
import UpdateEventModal from "../../modals/event/updteEventStatus";
import { actions, RootState } from "../../state/reducer";
import { statsBackend } from "../../services";

const EventListCard = (data: EventCardInfo) => {

  const dispatch = useDispatch();
  const [hasUndeadComments, setHasUnreadComments] = useState(false);
  const State = useSelector((state: RootState) => state);
  
  const isOutdated: boolean = (() => {
    if (!data.date_end || data.status_id !== 1) return false;
    const eventDate = new Date(data.date_end).getTime();
    const now = new Date().getTime();
    return now > eventDate;
  })();

  const session = State.session;

  const handleOpenModal = () => {
    dispatch(openModal({ component: UpdateEventModal,context: {
      event_id: data.event_id,
      onSave: () => {
        dispatch(actions.selectItem(generateRandomString(4)))
      },
      closeModal: () => dispatch(closeModal()), // Закрыть модальное окно через Redux
    }, }));
  };

  useEffect (() => {
    if (session)
    statsBackend.hasUnreadComments({
      tab_id: 1,
      item_id: data.event_id,
      user_id: session.id
    }).then((res) => {
      setHasUnreadComments(res.has);
    })
  }, [])

  const iconColor = (() => {
    switch (true) {
      case isOutdated:
        return "red";
      case data.status_id === 3:
        return "green";
      case data.status_id === 2:
        return "gray";
      default:
        return "yellow"    
    }
  })()

  return (
    <div className="eventCard homepageEventCard">
      <div className="flex">
        <div className={`icon eventIconColumn ${iconColor}`}>
          {isOutdated ? (
            <EventOutdateIcon width={32} height={32} />
          ) : data.status_id === 3 || data.status_id === 2 ? (
            <EventFinishedIcon width={32} height={32} />
          ) : (
            <EventPlannedIcon width={32} height={32} />
          )}
        </div>
        <div className="eventCardBody">
          <div className="eventRow flex between">
            <div className="flex">
              <div className={`eventTypeName${isOutdated ? " outdated" : ""}`}>
                {data.type_name}
              </div>
              <div className="eventDateInfo">
                {data.date_end
                  ? formatDateOfEvent(new Date(data.date_end))
                  : null}
              </div>
            </div>
            {isOutdated ? (
              <div className="toDoHeading warn">Событие просрочено</div>
            ) : null}
          </div>
          <div className="flex gap6 eventDateInfo">
            <span>{`${data.comment_count} ${getDeclinedWord(data.comment_count, "комментарий")}`}</span>
            {hasUndeadComments && <span className="unreadMark" />}
            </div>
    
          <div className="eventRow flex between" style={{ marginTop: 12 }}>
            <div className="eventBtnBlock flex gap10">
              {data.status_id === 1 && <div className="btn eventActionBtn ok" onClick={handleOpenModal}>Выполнить</div>}
              <a href={`/events/detail/${data.event_id}`}><div className="btn eventActionBtn edit">Редактировать</div></a>
            </div>
            <ShortManInfo phone={data.customer.phone} name={`Клиент: ${data.customer.name}`} />
          </div>
        </div>
      </div>
      {/* <p>
      <strong>Тип события:</strong> {event.type_id}
    </p> */}
    </div>
  );
};

export default EventListCard;
